import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
// import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import miscellaneousexpenses from '@/shared/http/repositories/business/miscellaneousexpenses.js'
import filterdetailsmiscellaneous from '@/views/private/miscellaneousreimbursement/components/tablelotspaid/components/filterdetailsmiscellaneous.vue'
import Tools from '@/components/tools/Tools.js'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import { derivaConsulta } from '@/views/private/miscellaneousreimbursement/rolesEscritaDiversos'
// Era 'DetailsPaidLots', igual ao componente da Viagem: todo `found in ---> <DetailsPaidLots>`
// no console ficava ambiguo entre os 2 modulos. O `name` daqui nao e referenciado em lugar
// nenhum (o da rota e string propria no router).
const name = 'DetailsMiscellaneousPaidLots'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    HeadDetailsGama,
    filterdetailsmiscellaneous
  },

  props: { },

  updated () { },

  data () {
    return {
      loteid: null,
      ArrayLotePagosDetalhes: [],
      dataSearch: {},
      infoDetalhes: {},
      LotesEmployee: [],
      modalDetalhes: {},
      funcionarioIdDetalhes: null,
      dataInicio: null,
      dataFinal: null,
      SomaDespesa: 0,
      SomaDespesaLote: 0,
      LotesPagosDetalhes: [],
      pedido: null,
      PedidoGerado: false
    }
  },
  mounted () {
    // this.onLoad()
  },

  computed: {
    // Read-only quando vier da tela de consulta do Diversos (tablepaidlots passa consulta=1).
    // Zera o gerar pedido. `consulta=1` nao pode ser a unica fonte -- e query string; sem
    // NENHUMA role de escrita do modulo tambem e leitura. Ver rolesEscritaDiversos.js.
    isConsulta () {
      return derivaConsulta(this.$route.query, this.hasRole)
    }
  },

  methods: {
    onLoad () {
      let param = new URLSearchParams(window.location.search)
      this.loteid = param.get('lote')
      this.getDetailsbyIds(this.loteid)
    },
    async getDetailsbyIds (loteid) {
      loading.push()
      this.dataSearch.EmpresaId = this.CompanySelected
      miscellaneousexpenses.GetLotesPagosByLoteDetalhes(loteid, this.$refs.tableGridLotePagoDetalhesDiversos.pagingLimit, this.$refs.tableGridLotePagoDetalhesDiversos.pagingIndex, this.dataSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridLotePagoDetalhesDiversos.LoadAllByData(Response)
          this.ArrayLotePagosDetalhes = Response.data.data
          this.LotesPagosDetalhes = this.ArrayLotePagosDetalhes
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    search (data) {
      this.dataSearch = data
      this.onLoad()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value !== 'N/D') {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    ModalPopup (event) {
      this.loteid = event.id
      this.funcionarioIdDetalhes = event.funcionarioId
      this.$refs['popupExpense'].show()
      this.modalInfo(event)
    },
    modalInfo (event) {
      if (event != null && event !== undefined) {
        this.infoDetalhes = event
      }
      miscellaneousexpenses.GetExpensesModalByLotes(this.infoDetalhes.id, this.infoDetalhes.funcionarioId, this.CompanySelected)
        .then((Response) => {
          this.loteid = this.infoDetalhes.id
          this.funcionarioIdDetalhes = this.infoDetalhes.funcionarioId
          this.getLotes()
          this.modalDetalhes = Response.data[0]
        })
    },
    getLotes () {
      miscellaneousexpenses.GetExpensesByLotes(this.loteid, this.funcionarioIdDetalhes, this.CompanySelected, this.$refs.tableGridLotePagoDetalhesModalDiversos.pagingLimit, this.$refs.tableGridLotePagoDetalhesModalDiversos.pagingIndex)
        .then((Response) => {
          this.loteid = null
          this.funcionarioIdDetalhes = null
          this.$refs.tableGridLotePagoDetalhesModalDiversos.LoadAllByData(Response)
          this.LotesEmployee = Response.data.data
          this.getTotalLotes(this.LotesEmployee)
        })
    },
    getTotalLotes (event) {
      this.SomaDespesa = event.map(Element => {
        return Element.total
      })
      const soma = this.SomaDespesa.reduce((acumulador, valorAtual) => {
        return acumulador + valorAtual
      }, 0)
      this.SomaDespesaLote = soma
    },
    showModalPedido (loteId) {
      this.loteId = loteId.id
      this.PedidoGerado = false
      this.$refs['ModalGerarPedido'].show()
    },
    cancelPedido () {
      this.loteId = null
      this.$refs['ModalGerarPedido'].hide()
    },
    showModalPedidoGerado () {
      loading.push()
      miscellaneousexpenses.GerarPedido({LoteId: this.loteId, FuncionarioId: null, EmpresaId: this.CompanySelected})
        .then((Response) => {
          loading.close()
          this.pedido = Response.data
          this.PedidoGerado = true
        })
        .catch((Error) => {
          toast.error('Erro ao gerar pedido!')
          loading.close()
          this.$refs['ModalGerarPedido'].hide()
        })
    },
    onExportAllImages () {
      loading.push()
      const payload = {loteId: this.infoDetalhes.id, funcionarioId: this.infoDetalhes.funcionarioId, empresaId: this.CompanySelected}
      console.log(payload)
      miscellaneousexpenses.GerarPDFComprovantes(payload)
        .then((Response) => {
          const fileURL = window.URL.createObjectURL(new Blob([Response.data], {
            type: 'application/pdf'
          }))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', 'comprovantes.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
          fileLink.remove()
          // this.PedidoGerado = true;
          loading.close()
        })
        .catch((Error) => {
          toast.error('Nenhuma imagem encontrada para gerar o PDF.')
          loading.close()
          this.$refs['ModalGerarPedido'].hide()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tablelotspaid/components/detailsmiscellaneouspaidlots.js